/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ time: NonNullable<unknown> }} Agent_Schedule_Last_RunInputs */



/**
* | output |
* | --- |
* | "Last run {time}" |
*
* @param {Agent_Schedule_Last_RunInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_schedule_last_run = /** @type {((inputs: Agent_Schedule_Last_RunInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Schedule_Last_RunInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Letzter Lauf ${i?.time}`)
	return /** @type {LocalizedString} */ (`Last run ${i?.time}`)
});